import { render, staticRenderFns } from "./Mods.vue?vue&type=template&id=5d152846&scoped=true&"
import script from "./Mods.vue?vue&type=script&lang=js&"
export * from "./Mods.vue?vue&type=script&lang=js&"
import style0 from "./Mods.vue?vue&type=style&index=0&id=5d152846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d152846",
  null
  
)

export default component.exports